// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import animate from 'animate.css'
import 'iview/dist/styles/iview.css'
import '@/assets/css/iconfont.css'
import '@/assets/css/base.css'
import http from '@/request/http.js'
// import {getCookie} from '@/assets/js/cookie.js'
import store from '@/store'

import { Layout, Header, Sider, Content, Row, Col, Upload, Button, Modal, Icon, Form, FormItem, Input, RadioGroup, Radio, Tabs, TabPane, Select, Option, CheckboxGroup, Checkbox, Poptip, Collapse, Panel, Table, Message, Tooltip, InputNumber, Page, Badge, Tree, Breadcrumb, BreadcrumbItem, DatePicker, Progress, Cascader, Spin, circle } from 'iview'
Vue.component('Layout', Layout)
Vue.component('Header', Header)
Vue.component('Sider', Sider)
Vue.component('Content', Content)
Vue.component('Row', Row)
Vue.component('Col', Col)
Vue.component('Upload', Upload)
Vue.component('Button', Button)
Vue.component('Modal', Modal)
Vue.component('Icon', Icon)
Vue.component('Form', Form)
Vue.component('FormItem', FormItem)
Vue.component('Input', Input)
Vue.component('RadioGroup', RadioGroup)
Vue.component('Radio', Radio)
Vue.component('Tabs', Tabs)
Vue.component('TabPane', TabPane)
Vue.component('Select', Select)
Vue.component('Option', Option)
Vue.component('CheckboxGroup', CheckboxGroup)
Vue.component('Checkbox', Checkbox)
Vue.component('Poptip', Poptip)
Vue.component('Collapse', Collapse)
Vue.component('Panel', Panel)
Vue.component('Table', Table)
Vue.component('Message', Message)
Vue.component('Tooltip', Tooltip)
Vue.component('InputNumber', InputNumber)
Vue.component('Page', Page)
Vue.component('Badge', Badge)
Vue.component('Tree', Tree)
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('BreadcrumbItem', BreadcrumbItem)
Vue.component('DatePicker', DatePicker)
Vue.component('Progress', Progress)
Vue.component('Cascader', Cascader)
Vue.component('Spin', Spin)
Vue.component('circle', circle)
Vue.prototype.$Message = Message
Vue.prototype.$Modal = Modal

Vue.use(animate)
// Vue.use(getCookie)

Vue.prototype.http = http

Vue.config.productionTip = false

Vue.prototype.noLogin = (msg) => { // 已登录时，登录帐号出现问题，例如：后台修改了密码
  Message.error(msg)
  if (msg == '未登录') {
    localStorage.removeItem("Flag")
    store.state.requireAuth = false
    document.cookie = "cook_cus_uid="
    document.cookie = "cook_cus_pwd="
    setTimeout(() => {
      router.push('/login')
    }, 100)
  }
}

function cookieObtain(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

// 进入路由时判断进入目标页面是否需要验证登录
router.beforeEach((to, from, next) => {
  var query = window.location.href.substring(1).split("?")
  if (query.length > 1) {
    var divisionone = query[1].split("&")
    var divisiontwo = []
    var parameter = {}
    for (var i in divisionone) {
      divisiontwo.push(divisionone[i].split('='))
    }
    for (var i = 0; i < divisiontwo.length; i++) {
      parameter[divisiontwo[i][0]] = divisiontwo[i][1]
    }
    next()
    if (parameter.cook_ShopId != '' && parameter.cook_cus_uid != '' && parameter.cook_cus_pwd != '' && parameter.cook_ShopId != 'undefined' && parameter.cook_cus_uid != 'undefined' && parameter.cook_cus_pwd != 'undefined' && parameter.cook_ShopId != undefined && parameter.cook_cus_uid != undefined && parameter.cook_cus_pwd != undefined) {
      for (var i = 0; i < divisiontwo.length; i++) {
        document.cookie = divisiontwo[i][0] + '=' + divisiontwo[i][1]
      }
      localStorage.setItem("Flag", "requireAuth");
      next({
        path: '/'
      })
    } else {
      next({
        path: '/login',
      })
    }
  } else {
    //获取用户登录成功后储存的登录标志
    let getFlag = localStorage.getItem("Flag")
    if (getFlag === "requireAuth" && cookieObtain('cook_ShopId') != '' && cookieObtain('cook_cus_uid') != '' || store.state.openmall) { // 如果登录标志存在且为requireAuth，即用户已登录
      // 设置vuex登录状态为已登录
      store.state.requireAuth = true
      next()
      // 如果已登录，还想想进入登录注册界面，则定向回首页
      if (!to.meta.requireAuth && to.name != 'Result' && !store.state.openmall) {
        //iViewUi友好提示
        Message.warning('请先退出登录!')
        next({
          path: '/'
        })
      }
    } else { // 如果登录标志不存在，即未登录
      if (to.meta.requireAuth) { // 用户想进入需要登录的页面，则定向回登录界面
        next({
          path: '/login',
        })
        //iViewUi友好提示
        // Message.warning('请先登录!')
      } else { // 用户进入无需登录的界面，则跳转继续
        next()
      }
    }
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


Vue.prototype.getCookie = (name) => {
  let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2])
  } else {
    return null
  }
  // if (name == 'cook_ShopId') return 317
  // if (name == 'cook_cus_uid') return 32
  // if (name == 'cook_cus_pwd') return 123456
}

// 获取当前网站网址 https://demo.huobianli.cn/
Vue.prototype.getWebsite = () => {
  return 'https://demo.huobianli.cn/'
  // return window.location.protocol + '//' + window.location.host + '/'
}

// 当前日期时间
Vue.prototype.getDateTime = () => {
  var date = new Date()
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  var hour = date.getHours()
  var minute = date.getMinutes()
  var second = date.getSeconds()
  return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute)
}
// 30天前日期时间
Vue.prototype.getThirtyDateTime = () => {
  var newsdate = new Date()
  var date = new Date(newsdate - 1000 * 60 * 60 * 24 * 30)
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  var hour = date.getHours()
  var minute = date.getMinutes()
  var second = date.getSeconds()
  return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js